
function initMap(id, lat, long) {
    const markerImage = "/static/images/kin.png";
    const mapElement = document.getElementById(id);

    const mapPosition = new google.maps.LatLng(lat, long);
    const mapOptions = {
        zoom: 15,
        minZoom: 6,
        maxZoom: 17,
        zoomControl:true,
        zoomControlOptions: {
            style:google.maps.ZoomControlStyle.TRUE
        },
        center: mapPosition,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        draggable: window.innerWidth > 900,
        scrollwheel: false,
        panControl:false,
        mapTypeControl:false,
        scaleControl:false,
        streetViewControl:false,
        overviewMapControl:false,
        rotateControl:false
    };

    const mapInitialiser = function mapInitialiser() {
        const map = new google.maps.Map(mapElement, mapOptions);

        const image = new google.maps.MarkerImage(markerImage, null, null, null, new google.maps.Size(118, 100));

        const marker = new google.maps.Marker({
            position: mapPosition,
            map: map,
            icon: image
        });

        google.maps.event.addDomListener(window, 'resize', function() {
            map.setCenter(mapPosition);
        });
    };

    return mapInitialiser;
}


function init(config) {
    if (window.google) {
        google.maps.event.addDomListener(window, 'load', initMap(config.mapId, config.latitude, config.longitude));
    } else if (window.mapElement) {
        window.mapElement.innerHTML = "<p class='u-text-center u-sentiment-error'>Google Maps is having trouble loading.</p>";
    }
}

export default { init }
